module.exports = __webpack_public_path__ + "09982c9f7fc665964b8713f0f741f382.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/projekte/lokalrunde-1.jpg
// module id = 664
// module chunks = 0